G.Input = G.Input || {};
G.Input.initializeCustomInput = function initializeCustomInput(element, optMinDragDistance) {

  // imports
  var EventType = G.Input.EventType;
  var utils = G.Utils;
  var storageUtils = G.StorageUtils;

  //

  return doInitializeCustomInput(element, optMinDragDistance);

  /**
   * @param element {Phaser.Sprite}
   * @param optMinDragDistance {number = 15}
   */
  function doInitializeCustomInput(element, optMinDragDistance) {
    addCustomInput(element);
    enableInputEvents(element, utils.defined(optMinDragDistance, 15));
    addInputEventListeners(element.events);
  }

  function addCustomInput(element) {
    element.customInput = createCustomInput();
  }

  function hasCustomInput(element) {
    return Boolean(element.customInput);
  }

  function enableInputEvents(element, minDragDistance) {
    // enable onInput* events
    element.inputEnabled = true;

    // enable onDrag* events
    initPhaserDrag(element.input, minDragDistance);
  }

  function initPhaserDrag(inputHandler, minDragDistance) {
    inputHandler.draggable = true;

    // Prevent phaser from actually dragging the element - we only need events
    inputHandler.allowHorizontalDrag = false;
    inputHandler.allowVerticalDrag = false;

    inputHandler.dragDistanceThreshold = minDragDistance;
  }

  function addInputEventListeners(events) {
    [
      { signal: events.onInputOver,  eventType: EventType.InputOver  },
      { signal: events.onInputOut,   eventType: EventType.InputOut   },
      { signal: events.onInputDown,  eventType: EventType.InputDown  },
      { signal: events.onInputUp,    eventType: EventType.InputUp    },
      { signal: events.onDragStart,  eventType: EventType.DragStart  },
      { signal: events.onDragUpdate, eventType: EventType.DragUpdate },
      { signal: events.onDragStop,   eventType: EventType.DragStop   }
    ].forEach(function forwardSignals(tuple) {
      var signal = tuple.signal;
      var eventType = tuple.eventType;
      signal.add(function onPhasersInputHandlerSignal(sourceElement, pointer) {
        handleCustomInput(sourceElement, pointer, eventType);
      });
    });
  }

  function handleCustomInput(sourceElement, pointer, eventType) {

    var interestedCandidates = [];

    pointer.interactiveCandidates.forEach(function(inputHandler) {
      var element = inputHandler.sprite;

      if (element && hasCustomInput(element)) {
        if (element.customInput.handleEventShared(eventType, pointer)) {
          interestedCandidates.push(element);
        }
      }
    });

    // Prepare priority based on render order
    interestedCandidates.sort(function(a, b) {
      // TODO: test with groups
      return (
        (a.renderOrderID === b.renderOrderID)
          ? 0
          : (a.renderOrderID < b.renderOrderID ? 1 : -1)
      );
    });

    // TODO: test inputEnabled manipulation

    // Prioritize the source element before anything else
    storageUtils.moveArrayElementToBeFirst(interestedCandidates, sourceElement);

    // handle event considering consumption
    var eventConsumed = false;
    for (var i = 0; i < interestedCandidates.length; ++i) {
      var customInput = interestedCandidates[i].customInput;
      if (eventConsumed) {
        customInput.cancelEvent(eventType);
      } else {
        eventConsumed = customInput.handleEventExclusive(eventType, pointer);
      }
    }
  }

  function createCustomInput() {

    var handlers = [];

    return {
      // custom input handler interface
      handleEventShared:    handleEventShared,
      handleEventExclusive: handleEventExclusive,
      cancelEvent:          cancelEvent,

      // custom
      addHandler: addHandler
    };

    // FIXME:
    /* Using phaser's input events doesn't work well when you end interaction outside the element
     * E.g. a scrollable popup with button inside. Scrolling it by starting drag on button
     * and ending outside the popup will trigger no events */
    /**
     * @param handler {Object} a handler that implements custom input handler interface
     * @param handler.handleEventShared {(G.Input.EventType, Phaser.Poitner) => boolean}
     * @param handler.handleEventExclusive {(G.Input.EventType, Phaser.Poitner) => boolean}
     * @param handler.cancelEvent {(G.Input.EventType) => void}
     */
    function addHandler(handler) {
      handlers.push(handler);
    }

    function handleEventShared(eventType, pointer) {
      var some = false;
      for (var i = 0; i < handlers.length; ++i) {
        some = handlers[i].handleEventShared(eventType, pointer) || some;
      }
      return some;
    }

    function handleEventExclusive(eventType, pointer) {
      var consumed = false;
      for (var i = 0; i < handlers.length; ++i) {
        if (!consumed) {
          // TODO: what if it triggers callback that modifiers the `handlers` array?
          consumed = handlers[i].handleEventExclusive(eventType, pointer);
        } else {
          handlers[i].cancelEvent(eventType);
        }
      }
      return consumed;
    }

    function cancelEvent(eventType) {
      for (var i = 0; i < handlers.length; ++i) {
        handlers[i].cancelEvent(eventType);
      }
    }
  }

};
